import React, {Component} from "react";
import axios from "axios";
import Check from './Check';
import {  Redirect } from 'react-router-dom';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/OrdersAPI/`
})

class Order extends Component{
    constructor(props) {
        super(props);
        this.state = {
            title:props.location.state.title,
            image:props.location.state.img,
            itemPrice:props.location.state.price,
            bill:props.location.state.price,
            seller:props.location.state.seller,
            buyer:props.location.state.buyer,
            sellerID:props.location.state.sellerID,
            buyerID:props.location.state.buyerID,
            itemID:props.location.state.itemID,
            paymentMethod:'not selected',
            qty:1,
            mobile:'',
            address:'',
            orderCompleted: false
        }
        
      }
    increaseQty= (e) => {
        this.setState({qty: this.state.qty + 1})
    }
    decreaseQty = (e) => {
        if(this.state.qty > 1){
            this.setState({qty: this.state.qty - 1})
        }
    }
    handleCOD=()=>{
        this.setState({paymentMethod:'cod'})
    }
    handleOnlinePayment=()=>{
        this.setState({paymentMethod:'online'})
    }
    onSubmit = (e) => {
        e.preventDefault();
        this.setState({paymentMethod:'not selected'})
    }
    handleMobileNo=(e) => {
        this.setState({mobile:e.target.value})
    }
    handleAddress=(e) => {
        this.setState({address:e.target.value})
    }
    preparePayload = () => {
        // Prepare order items
        let order_items = [
            {
                seller: this.state.sellerID,
                item:this.state.itemID,
                price: this.state.itemPrice * this.state.qty,
                quantity: this.state.qty
            }
        ]
        let data = {
            buyer: this.state.buyerID,
            payment_method: this.state.paymentMethod,
            address: this.state.address,
            mobile: this.state.mobile,
            price: this.state.itemPrice * this.state.qty + 70,
            order_items: order_items
        }
        return data
    }
    addOrder =async () => {
        let data = this.preparePayload()

        try {
            let res = await api.post('/',data);
            if(res?.status !== 201){
                alert("Can't place order!")
            }else{
                alert("Order Placed Successfully!");
                this.setState({orderCompleted: true})
            }
        }
        catch{
            alert("Can't place order!");
        }
    }
    onchange = (data) => {
        this.setState({paymentMethod:data})
    }

    
    render() {
        return(
        <>
            <br/><br/>
            { this.state.orderCompleted && <Redirect to="/" />}
            <div className='container mt-5'>
            <div className='row pt-3 pb-3'>
                <div className='col col-lg-8 w3-light-gray'>
                <table className="table table-borderless">
                <thead className='w3-gray'>
                    <tr>
                    <th scope="col" style={{width:'50%'}}>Item</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Price</th>
                    </tr>
                </thead>
                
                <tbody>
                    <tr>
                    <td><br/>
                        <img src={this.state.image} style={{height:'150px', width:'150px'}} alt="..." />
                        <p style={{textAlign:'justify', fontSize:'13px', width:'250px'}} className='me-5 mt-3'>{this.state.title}</p>
                    </td>
                    <td>
                    <div className="btn-group mt-5 pt-4" role="group" >
                        <button type="button" className="btn btn-secondary btn-primary" onClick={this.decreaseQty}>-</button>
                        <button type="button" className="btn btn-secondary btn-primary">{this.state.qty}</button>
                        <button type="button" className="btn btn-secondary btn-primary" onClick={this.increaseQty}>+</button>
                    </div>
                    </td>
                    <td>
                        <h3 className='pt-4 mt-5' style={{color:'black'}}>Rs. {this.state.itemPrice * 1}</h3>
                    </td>
                    </tr>
                </tbody>
                </table><br/>
                <p style={{fontSize:'12px', textAlign:'end'}} ><b>Shipped By:</b> {this.state.seller}</p>
                </div>
                <div className='col w3-light-gray ms-2'>
                    <h5><b>Shipping & Billing</b></h5><hr/>
                    <p>{this.state.buyer}</p>
                <form onSubmit={e => this.onSubmit(e)}>
                    <div className="input-group input-group-sm mb-3">
                    <div className="input-group-prepend">
                    <span className="input-group-text bg-primary" style={{width:'50px', paddingLeft: '15px'}} ><i className='fas fa-phone-alt'/></span>
                    </div>
                    <input type="text" className="form-control" placeholder="Enter your Mobile No." onChange={this.handleMobileNo} required />
                    </div>

                    <div className="input-group input-group-sm mb-3">
                    <div className="input-group-prepend">
                    <span className="input-group-text bg-primary" style={{width:'50px', paddingLeft: '18px'}} ><i className='fas fa-map-marker-alt'/></span>
                    </div>
                    <textarea type="text" className="form-control" placeholder="Enter Address eg. House# 123, Street# 123, ABC Road" onChange={this.handleAddress} required  />
                    </div>
                    <h5>Order Summary</h5>
                    <div className='row'>
                        <div className='col'>
                        <p style={{fontSize:'12px', color:'gray'}}>Sub Total <br/>Shipping Fee</p>
                        </div>
                        <div className='col me-5' style={{textAlign:'end'}}>
                        <p style={{fontSize:'12px', color:'gray'}}>Rs. {this.state.itemPrice * this.state.qty}<br/>Rs. 70</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <span style={{color:'black', fontSize:'19px'}}>Total</span>
                        </div>
                        <div className='col me-5' style={{textAlign:'end'}}>
                            <span style={{color:'black', fontSize:'19px'}}> Rs. {this.state.itemPrice * this.state.qty+ 70}</span>
                        </div>
                    </div><br/>
                    {(this.state.mobile === '' || this.state.address === '') ? 
                    <button type="submit" className="btn btn-primary mb-3" style={{width:'300px', marginLeft: '50px'}}><i className="fa fa-credit-card" /> Proceed to Pay </button>
                    :
                    <button type="submit" className="btn btn-primary mb-3" style={{width:'300px', marginLeft: '50px'}} data-bs-toggle="modal" data-bs-target="#payment"><i className="fa fa-credit-card" /> Proceed to Pay </button>
                    }
                    </form>
                </div>
            </div>
            </div>

            {/* form for payment */} 

            <div className="modal fade" id="payment" tabIndex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Order Confirmation</h5>
                    {this.state.paymentMethod === 'stripe' ? null :<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>}
                </div>


                <div className="modal-body">
                {(this.state.paymentMethod === 'not selected') ?
                    <>
                    <b>Select a payment Method</b><br/><br/>
                    <button type="button" className="btn btn-primary ms-5" onClick={this.handleCOD} ><i className='fa fa-money-bill'/> Cash on Delivery  </button>
                    <button type="button" className="btn btn-primary ms-5" onClick={this.handleOnlinePayment} ><i className='fa fa-credit-card'/> Online Payment </button>
                    <br/><br/>
                    </>
                    :(this.state.paymentMethod === 'cod' || this.state.paymentMethod === 'stripe') ?
                        <>
                        <div className='row'>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                Buyer Name <br/>Mobile No. <br/>Address 
                                </p>
                            </div>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    {this.state.buyer}<br/>{this.state.mobile}<br/>{this.state.address}
                                </p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    Item Quantity<br/>Total Bill
                                </p>
                            </div>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    {this.state.qty}<br/>{this.state.itemPrice * this.state.qty+ 70}
                                </p>
                            </div>
                        </div>
                        </>
                    :
                    <Check data={this.paymentMethod} price={this.state.itemPrice * this.state.qty+ 70} onchange={(e) => { this.onchange(e) }}/>
                } 
                </div>

                
                <div className="modal-footer">
                    {this.state.paymentMethod === 'stripe' ? null :
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    }
                    {(this.state.paymentMethod === 'not selected' || this.state.paymentMethod === 'online') ? null :
                    <button type="reset" className="btn btn-primary btn-primary"  data-bs-dismiss="modal" onClick={this.addOrder} >Confirm Order</button>
                    }
                </div>
                </div>
            </div>
            </div>
        </>
        )
     }
}
export default Order;